import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { UPDATE_CARDNAME, STATUS_SUCCESS_CODE, CAN_CREATE_SAVINGS_ACC } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import LineBreaks, { addLineBreaks, displayErrorMessage, displaySuccessMessage, MoreServices, retrieveData } from '../../../utils';
import check_img from '../../../assets/images/check_3x.png'
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import ClimbImg from '../../../assets/images/illo-climb.png';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import FooterContent from '../../../components/CustomComponents/Footer';
import HomeLayout from '../../../components/Layout/HomeLayout';
import HomeHeader from '../../../components/CustomComponents/HomeHeader';
import DynamicCard from '../../../components/CustomComponents/DynamicCard';
import Loader from '../../../components/CustomComponents/Loader';
import CustomAlertModel from '../../../components/CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../components/LogFirebaseEvents';
import { width } from '../../../components/CustomComponents/DynamicCard/DynamicCardStyles';
import Approved from '../../../assets/images/Approved.png'
import KudzuLogo from '../../../assets/images/kudzuLogo.png'
import CustomModalPlus from '../../helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../membershipEnrollmentScreens';
import CustomCarousel from '../../helpers/customCarousel';

const ManageMembershipCancelation = ({ transactionDatas, onViewAllClick, viewAll }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const { t } = useTranslation(); // Hook to access translation functions
    const cards = useSelector(state => JSON.parse(state.userCards));
    const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [editClicked, setEditClicked] = useState(false);
    const [showCheckImage, setshowCheckImage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const selectedItem = cards?.[0]
    const [newName, setNewName] = useState((selectedItem != undefined && selectedItem != null) ? selectedItem.NickName : "");

    const [loading, setLoading] = useState(false);
    const [infoMessage, setinfoMessage] = useState('');
    const [responseCode, setResponseCode] = useState('');
    const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "w-[240px] md:w-[399px] font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgPlusStyles = "sm:w-[399px] font-hanken-grotesk modal-title mt-[17px] md:text-[16px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-[400] cursor-pointer pointer-events-none text-white";

    
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [allButtonsDisable, setAllButtonsDisable] = useState(false);

    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);



    const textArray = [
        { paragraph: t('Access_Direct_Deposite_Text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Annual_Percentage_Text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Additional_Exclusive_text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Withdrawal_text'), imageUrl: require('../../.././assets/images/Check_Green.png') }
    ];
    const cardTextArray = [
        { paragraph: t('APL_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
        { paragraph: t('AllPoint_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
        { paragraph: t('Access_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
    ];



    const handleRevertClick = () => {
        setinfoMessage('');
        setEditClicked(false);
    };



    const subComponent = () => {
        return (
            <div className=' flex justify-start items-start'>
                <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
                    () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
            </div>
        )
    }

    const slidesDataForFeatureCarousel = [
        {
            heading: t("welcm_to_kudzu+"),
            paragraph: t("Remember_that_your_membership"),
            videoUrl: require('../../../assets/videos/freeTrailVideos/kudzu-plus-logo.mp4')
        },
        {
            heading: t("Go_Pro_with_Dark_Mode"),
            paragraph: t("Enjoy_your_new_nightshade_app_theme"),
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/Go-Pro-with-Dark-Mode.png')
        },
        {
            heading: t("Stay_Protected_with_Covered_by_Kudzu+"),
            paragraph: <p>{t("We’ve_got_you_covered_up_to_$100")} <span className='text-[#94C3E8] cursor-pointer'>{t("here")}</span> </p>,
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/spendin-saving.png')
        },
        {
            heading: t("Set_Intentions_with_Savings _Goals"),
            paragraph: t("Customizable_Automatic_text"),
            videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
        },
        {
            heading: t("And_Even_Mor_Kudzu+_Perks"),
            paragraph: t("Unlock_a_higher_interest_savings_APY"),
            imageUrl: require('../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
            getstartTrue: true
        },
    ];





    useEffect(() => {
    }, [cards, dispatch]);

    const closeCustomAlertModal = () => {

        setShowModel(false);
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        if (btn1Text == t("enroll")) {
            navigate('/SetupSavingsAccount')
            dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
        } else if (btn1Text == t('home')) {
            navigate('/home')
        }

    }
    const onCancelBtnClick = () => {
        setShowModel(false)
        showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);
    }
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setSavingsTheme(savingsTheme)
        setisBorderNone(isBorderNone)
        setIsSubFooter(isSubFooter)
    }


    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,allButtonsDisable) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
        setAllButtonsDisable(allButtonsDisable)

    }

   
    //without button card
    const footerContent = () => {
        return (
            < FooterContent
                cardHeight={'200px'}
                backgroundColor={'#D3D3D3'}
                btnBgColor={'#30BC89'}
                btnTextColor={'#FFFFFF'}
                isSubheadingwidth={true}
                textArray={cardTextArray}
                // highlightTextColor={'#0C4437'}
                // subHeaderTextColor={'#0C4437'}
                highlightText={'Kudzu'}
                // subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
                subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
                image={KudzuLogo}
                buttonEnabled={false}
                buttonText={t("Button_text")} isSpace={true}
                type={'Kudzu+_card'}
                footerBtnAction={() => {
                    // showAlertModalPlus(true, t(""), addLineBreaks(t("earn_1.25_apy_on_your_savings_account_with_kudzu+")), addLineBreaks(t('learn_and_grow_with_a_free_3_month_kudzu_upgrade')), true, true, t('Learn_More'), t('No_Thanks'), true, require('.././../../assets/kudzu-plus-images/savingsTransferPlusbanner.png'), "", true, "#262B3A", addLineBreaks(t('4.95_per_month_after_first_3_month_after_charged_automatically_cancel_anytime')), true, '', false, false, true, true);
                }}
                borderDirection={'odd'}
            />
        )

    }
    
    const enrollSavingsFooterContent = () => {
        return (

            < FooterContent
                cardHeight={'200px'}
                backgroundColor={'#324261'}
                btnBgColor={'#30BC89'}
                btnTextColor={'#FFFFFF'}
                isSubheadingwidth={true}
                textArray={textArray}
                // highlightTextColor={'#0C4437'}
                // subHeaderTextColor={'#0C4437'}
                highlightText={t('Kudzu+')}
                // subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
                subHeaderText={LineBreaks(t("set_aside_funds_savings"))}
                image={Approved}
                buttonEnabled={true}
                buttonText={t("Button_text")} isSpace={true}
                buttonCancelText={t("Cancel_Kudzu_membership")}
                type={'Kudzu+'}
                footerBtnAction={() => {
                    debugger;
                    logFirebaseEvents("ManageMembershipCancelation", "Explore_Features_&_Benefits_Clicked", "Explore_Features_&_Benefits_Clicked", "", "");
                    const currentPath = { currentPathFromStore: location.pathname };
                    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                    showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '', <CustomCarousel slidesData={slidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} finalButtontextChange={t('done')} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />, true, "", "", true, "", false, false, false,false,true);
                }}
                footerBtnActionCancelKudzu={() =>{
                   logFirebaseEvents("ManageMembershipCancelation", "Cancel_Kudzu+_Membership_Clicked", "Cancel_Kudzu+_Membership_Clicked", "", "");
                    const currentPath = { currentPathFromStore: location.pathname };
                    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
                    showAlertModalPlus(true, t("thanks"), t("Do_you_want_to_downgrade_to_Kudzu"), t("Your_Kudzu+_features_will_still"), true, true, t('Downgrade_to_Kudzu'), t('Cancel'), true, require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A",'', true, '', false, true, false, true,false);
                }}
                borderDirection={'even'}
            />
        )
    }

    const closeModelPlus = () => {
    logFirebaseEvents("ManageMembershipCancelation", "Close_clicked", "Close_clicked", "", "");
      setShowPlusModal(false)
    }

    const onAcptBtnClickPlusModal = () => {
    logFirebaseEvents("ManageMembershipCancelation", "downgrade_to_kudzu_Clicked", "downgrade_to_kudzu_Clicked", "", "");
       navigate("/kudzuplusSecurity", { state: { type: t('downgrad_to_kudzu_plus') } });
    }

    const onCancelBtnClickPlusModal = () => {
    logFirebaseEvents("ManageMembershipCancelation", "Cancel_clicked", "Cancel_clicked  ", "", "");
        setShowPlusModal(false)
    }

    return (

        <HomeLayout>
              
            <HomeHeader heading={addLineBreaks(t("Kudzu_membership_text"))} isHeaderCaption={true} />
            {showCarouselScreenShow &&
               <MemnershipEnrollmentScreens />}
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]    animate__animated animate__fadeInRight '>
                <DynamicCard
                    header={true}
                    footer={false}
                    CardRadius={true}
                    HeaderRadius={true}
                    isWhite={true}
                    cardWidth={width.homeCard}
                >

                    <div className="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]  lg:text-[26px] md:text-[22px]  sm:text-[20px] text-[20px] leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
                        {t('manage_membership')}
                    </div>

                    <div className='border-t-[2.5px] border-[#A3CEBB] flex justify-center flex-col sm:mx-0 mx-4'>
                        <div className='flex flex-col justify-center mt-5 border-[#D1E7DD] items-center sm:mx-0 mx-4 mb-10'>
                            {enrollSavingsFooterContent()}
                            {footerContent()}
                        </div>
                    </div>

                    {loading && <Loader />}
                </DynamicCard>
                {/* {savingsCardAvailable == false ? enrollSavingsFooterContent() : footerContent()} */}
            </div>
            <CustomAlertModel isOpen={showModel}
                modalBg={!isSubFooter && 'bg-[#E4F1EB]'}
                btn1BorderColor={!isSubFooter && '#30BC89'}
                btn1TextColor={!isSubFooter && '#FEFAEE'}
                btn1BrExist={!isSubFooter && true}
                btn2TextColor={!isSubFooter && '#559C7E'}
                btn1BgColor={!isSubFooter && '#30BC89'}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[#0C4437]' : 'text-[#0C4437]'}`}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                isBorderNone={isBorderNone}
                subFooter={isSubFooter && subComponent()}
            />
           <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                // summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}><span className='text-[#94C3E8] font-serif-pro'>{btn1Text ? t('are_you_sure') : ""}</span><span>{headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn1TextColor={'#94C3E8'}
                btn2TextColor={'#94C3E8'}
                borderWhite={'2px solid #94C3E8'}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                allButtonsDisable={allButtonsDisable}
            />
            {isLoading && <Loader />}
        </HomeLayout>


    )
}

export default ManageMembershipCancelation;
